import request from '@/utils/request';

export function indexHeaderStatistics(data) {
  return request({
    url: '/home/statistics/queryHomeHeadStatistics',
    method: 'POST',
    data
  });
}
export function indexUserStatistics(data) {
  return request({
    url: '/home/statistics/queryHomeLineStatistics',
    method: 'POST',
    data
  });
}
export function exitBtn(data) {
  return request({
    url: '/oauth/loginOut',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/index.js